<template>

  <m-card519 :image="content.thumbnail" :alt="content.title">  </m-card519>


</template>

<script>
import {CardComputed} from "./CardComputed";
import mCard519 from "../../Cards/Card519";
import mA from '../../Tags/A'
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";


export default {
  name: "ContentCard504",
  methods: {contentSlicer},
  components: {mCard519, mA},
  props: {
    content: {}
  },
  computed: {
    ...CardComputed
  },
  mounted() {

  }

}
</script>

<style scoped>
.description-card{
  font-size: 0.875em;

}

.title-card{
  font-size: 19px;

}

.show-button-content-501{
  font-size: 15px;

}

.icon-show-content{
  font-size: 0.875em;

}

</style>